export enum DelimiterType {
    Tab = 'tab',
    Comma = 'comma',
    Pipe = 'pipe',
    Semicolon = 'semicolon',
}
